module.exports = __webpack_public_path__ + "img/active-past2.cbcdad7e.jpg";